import { getHeaders } from '@utility/helperFunction';
export const CALL_SLOT_ASSIGN_REQUESTED = 'cubby/CALL_SLOT_ASSIGN_REQUESTED';
export const CALL_SLOT_ASSIGN_SUCCESS = 'cubby/CALL_SLOT_ASSIGN_SUCCESS';
export const CALL_SLOT_ASSIGN_FAILURE = 'cubby/CALL_SLOT_ASSIGN_FAILURE';

export const UPDATE_ORDER_STATUS_REQUESTED = 'orderstatus/UPDATE_ORDER_STATUS_REQUESTED';
export const UPDATE_ORDER_STATUS_SUCCESS = 'orderstatus/UPDATE_ORDER_STATUS_SUCCESS';
export const UPDATE_ORDER_STATUS_FAILURE = 'orderstatus/UPDATE_ORDER_STATUS_FAILURE';

export const ORDER_PICKED_UP_REQUESTED = 'orderstatus/ORDER_PICKED_UP_REQUESTED';
export const ORDER_PICKED_UP_SUCCESS = 'orderstatus/ORDER_PICKED_UP_SUCCESS';
export const ORDER_PICKED_UP_FAILURE = 'orderstatus/ORDER_PICKED_UP_FAILURE';

export const SYNC_CHECK_REQUESTED = 'syncCheck/SYNC_CHECK_REQUESTED';
export const SYNC_CHECK_SUCCESS = 'syncCheck/SYNC_CHECK_SUCCESS';
export const SYNC_CHECK_FAILURE = 'syncCheck/SYNC_CHECK_FAILURE';

export const SEND_SMS_REQUESTED = 'syncCheck/SEND_SMS_REQUESTED';
export const SEND_SMS_SUCCESS = 'syncCheck/SEND_SMS_SUCCESS';
export const SEND_SMS_FAILURE = 'syncCheck/SEND_SMS_FAILURE';

export const GET_CUSTOM_SMS_TEMPLATES_REQUESTED = 'syncCheck/GET_CUSTOM_SMS_TEMPLATES_REQUESTED';
export const GET_CUSTOM_SMS_TEMPLATES_SUCCESS = 'syncCheck/GET_CUSTOM_SMS_TEMPLATES_SUCCESS';
export const GET_CUSTOM_SMS_TEMPLATES_FAILURE = 'syncCheck/GET_CUSTOM_SMS_TEMPLATES_FAILURE';

export const UPDATE_PRINT_CHECK_REQUESTED = 'printCheck/UPDATE_PRINT_CHECK_REQUESTED';
export const UPDATE_PRINT_CHECK_SUCCESS = 'printCheck/UPDATE_PRINT_CHECK_SUCCESS';
export const UPDATE_PRINT_CHECK_FAILURE = 'printCheck/UPDATE_PRINT_CHECK_FAILURE';

export const GET_PRINT_ORDER_TICKET_REQUESTED = 'printCheck/GET_PRINT_ORDER_TICKET_REQUESTED';
export const GET_PRINT_ORDER_TICKET_SUCCESS = 'printCheck/GET_PRINT_ORDER_TICKET_SUCCESS';
export const GET_PRINT_ORDER_TICKET_FAILURE = 'printCheck/GET_PRINT_ORDER_TICKET_FAILURE';

export const TABLE_RECEIPT_REQUESTED = 'printCheck/TABLE_RECEIPT_REQUESTED';
export const TABLE_RECEIPT_SUCCESS = 'printCheck/TABLE_RECEIPT_SUCCESS';
export const TABLE_RECEIPT_FAILURE = 'printCheck/TABLE_RECEIPT_FAILURE';

export const SEND_RECEIPT_TO_EMAIL_REQUESTED = 'printCheck/SEND_RECEIPT_TO_EMAIL_REQUESTED';
export const SEND_RECEIPT_TO_EMAIL_SUCCESS = 'printCheck/SEND_RECEIPT_TO_EMAIL_SUCCESS';
export const SEND_RECEIPT_TO_EMAIL_FAILURE = 'printCheck/SEND_RECEIPT_TO_EMAIL_FAILURE';

export const GET_MEMBER_DETAILS_REQUESTED = 'printCheck/GET_MEMBER_DETAILS_REQUESTED';
export const GET_MEMBER_DETAILS_SUCCESS = 'printCheck/GET_MEMBER_DETAILS_SUCCESS';
export const GET_MEMBER_DETAILS_FAILURE = 'printCheck/GET_MEMBER_DETAILS_FAILURE';

export const SEND_RECEIPT_TO_SMS_REQUESTED = 'printCheck/SEND_RECEIPT_TO_SMS_REQUESTED';
export const SEND_RECEIPT_TO_SMS_SUCCESS = 'printCheck/SEND_RECEIPT_TO_SMS_SUCCESS';
export const SEND_RECEIPT_TO_SMS_FAILURE = 'printCheck/SEND_RECEIPT_TO_SMS_FAILURE';

export const GET_FUTURE_ORDERS_SUMMARY_REQUESTED = 'future/GET_FUTURE_ORDERS_SUMMARY_REQUESTED';
export const GET_FUTURE_ORDERS_SUMMARY_SUCCESS = 'future/GET_FUTURE_ORDERS_SUMMARY_SUCCESS';
export const GET_FUTURE_ORDERS_SUMMARY_FAILURE = 'future/GET_FUTURE_ORDERS_SUMMARY_FAILURE';

export const GET_FUTURE_ORDER_DETAIL_REQUESTED = 'future/GET_FUTURE_ORDER_DETAIL_REQUESTED';
export const GET_FUTURE_ORDER_DETAIL_SUCCESS = 'future/GET_FUTURE_ORDER_DETAIL_SUCCESS';
export const GET_FUTURE_ORDER_DETAIL_FAILURE = 'future/GET_FUTURE_ORDER_DETAIL_FAILURE';

export const SEND_TEXT_TO_PAY_REQUESTED = 'printCheck/SEND_TEXT_TO_PAY_REQUESTED';
export const SEND_TEXT_TO_PAY_SUCCESS = 'printCheck/SEND_TEXT_TO_PAY_SUCCESS';
export const SEND_TEXT_TO_PAY_FAILURE = 'printCheck/SEND_TEXT_TO_PAY_FAILURE';

export const ACKNOWLEDGE_NOTIFICATION_REQUESTED = 'notification/ACKNOWLEDGE_NOTIFICATION_REQUESTED';
export const ACKNOWLEDGE_NOTIFICATION_SUCCESS = 'notification/ACKNOWLEDGE_NOTIFICATION_SUCCESS';
export const ACKNOWLEDGE_NOTIFICATION_FAILURE = 'notification/ACKNOWLEDGE_NOTIFICATION_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  futureOrdersSummary: null,
};

const setLoadingState = state => ({
  ...state,
  loading: true,
  loaded: false,
  error: false,
});

const setLoadedState = state => ({
  ...state,
  loading: false,
  loaded: true,
  error: false,
});

const setErrorState = state => ({
  ...state,
  loading: false,
  loaded: false,
  error: true,
});

export default (state = initialState, action) => {
  switch (action.type) {

    case CALL_SLOT_ASSIGN_REQUESTED:
    case UPDATE_ORDER_STATUS_REQUESTED:
    case ORDER_PICKED_UP_REQUESTED:
    case SYNC_CHECK_REQUESTED:
    case SEND_SMS_REQUESTED:
    case GET_CUSTOM_SMS_TEMPLATES_REQUESTED:
    case UPDATE_PRINT_CHECK_REQUESTED:
    case GET_PRINT_ORDER_TICKET_REQUESTED:
    case TABLE_RECEIPT_REQUESTED:
    case SEND_RECEIPT_TO_EMAIL_REQUESTED:
    case SEND_RECEIPT_TO_SMS_REQUESTED:
    case GET_MEMBER_DETAILS_REQUESTED:
    case GET_FUTURE_ORDERS_SUMMARY_REQUESTED:
    case GET_FUTURE_ORDER_DETAIL_REQUESTED:
    case SEND_TEXT_TO_PAY_REQUESTED:
    case ACKNOWLEDGE_NOTIFICATION_REQUESTED:
      {
        return setLoadingState(state);
      }

    case CALL_SLOT_ASSIGN_SUCCESS:
    case UPDATE_ORDER_STATUS_SUCCESS:
    case ORDER_PICKED_UP_SUCCESS:
    case SYNC_CHECK_SUCCESS:
    case SEND_SMS_SUCCESS:
    case GET_CUSTOM_SMS_TEMPLATES_SUCCESS:
    case UPDATE_PRINT_CHECK_SUCCESS:
    case GET_PRINT_ORDER_TICKET_SUCCESS:
    case TABLE_RECEIPT_SUCCESS:
    case SEND_RECEIPT_TO_EMAIL_SUCCESS:
    case SEND_RECEIPT_TO_SMS_SUCCESS:
    case GET_MEMBER_DETAILS_SUCCESS:
    case GET_FUTURE_ORDERS_SUMMARY_SUCCESS:
    case GET_FUTURE_ORDER_DETAIL_SUCCESS:
    case SEND_TEXT_TO_PAY_SUCCESS:
    case ACKNOWLEDGE_NOTIFICATION_SUCCESS:
      {
        return setLoadedState(state);
      }
    case GET_FUTURE_ORDERS_SUMMARY_SUCCESS:
      {
        return {...setLoadedState(state), futureOrdersSummary: action.payload};
      }

    case CALL_SLOT_ASSIGN_FAILURE:
    case UPDATE_ORDER_STATUS_FAILURE:
    case ORDER_PICKED_UP_FAILURE:
    case SYNC_CHECK_FAILURE:
    case SEND_SMS_FAILURE:
    case GET_CUSTOM_SMS_TEMPLATES_FAILURE:
    case UPDATE_PRINT_CHECK_FAILURE:
    case GET_PRINT_ORDER_TICKET_FAILURE:
    case TABLE_RECEIPT_FAILURE:
    case SEND_RECEIPT_TO_EMAIL_FAILURE:
    case SEND_RECEIPT_TO_SMS_FAILURE:
    case GET_MEMBER_DETAILS_FAILURE:
    case GET_FUTURE_ORDERS_SUMMARY_FAILURE:
    case GET_FUTURE_ORDER_DETAIL_FAILURE:
    case SEND_TEXT_TO_PAY_FAILURE:
    case ACKNOWLEDGE_NOTIFICATION_FAILURE:
      {
        return setErrorState(state);
      }

    default:
      return state;
  }
};

export const cubbySlotAssignApi = data => {
  const headers = getHeaders();
  return {
    types: [
      CALL_SLOT_ASSIGN_REQUESTED,
      CALL_SLOT_ASSIGN_SUCCESS,
      CALL_SLOT_ASSIGN_FAILURE,
    ],
    promise: client =>
      client.post('cubbyAssign', {
        data,
        headers,
      }),
  };
};

export const updateOrderStatus = data => {
  const headers = getHeaders();
  return {
    types: [
      UPDATE_ORDER_STATUS_REQUESTED,
      UPDATE_ORDER_STATUS_SUCCESS,
      UPDATE_ORDER_STATUS_FAILURE,
    ],
    promise: client => client.post('updateOrderStatus', { data, headers }),
  };
};

export const newUpdateOrderStatus = (data, type) => {
  const headers = getHeaders();
  return {
    types: [
      UPDATE_ORDER_STATUS_REQUESTED,
      UPDATE_ORDER_STATUS_SUCCESS,
      UPDATE_ORDER_STATUS_FAILURE,
    ],
    promise: client => client.post(`newUpdateOrderStatus/${type}`, { data, headers }),
  };
};
export const orderPickedUp = data => {
  const headers = getHeaders();
  return {
    types: [
      ORDER_PICKED_UP_REQUESTED,
      ORDER_PICKED_UP_SUCCESS,
      ORDER_PICKED_UP_FAILURE,
    ],
    promise: client => client.post('orderPickedUp', { data, headers }),
  };
};

export const newOrderPickedUp = (data, type) => {
  const headers = getHeaders();
  return {
    types: [
      ORDER_PICKED_UP_REQUESTED,
      ORDER_PICKED_UP_SUCCESS,
      ORDER_PICKED_UP_FAILURE,
    ],
    promise: client => client.post(`newOrderPickedUp/${type}`, { data, headers }),
  };
};

export const syncCheck = (id) => {
  const headers = getHeaders();
  return {
    types: [
      ORDER_PICKED_UP_REQUESTED,
      ORDER_PICKED_UP_SUCCESS,
      ORDER_PICKED_UP_FAILURE,
    ],
    promise: client => client.post(`updateSyncCheck/${id}`, { headers }),
  };
};

export const fireboardSendSms = (data) => {
  const headers = getHeaders();
  return {
    types: [
      SEND_SMS_REQUESTED,
      SEND_SMS_SUCCESS,
      SEND_SMS_FAILURE,
    ],
    promise: client => client.post('fireboardSendSMS', { data, headers }),
  };
};


export const getCustomSmsTemplates = (storeId) => {
  const headers = getHeaders();
  return {
    types: [
      GET_CUSTOM_SMS_TEMPLATES_REQUESTED,
      GET_CUSTOM_SMS_TEMPLATES_SUCCESS,
      GET_CUSTOM_SMS_TEMPLATES_FAILURE,
    ],
    promise: client => client.get(`customSmsTemplates/${storeId}`, { headers }),
  };
};

export const printCheck = (data) => {
  const headers = getHeaders();

  return {
    types: [
      UPDATE_PRINT_CHECK_REQUESTED,
      UPDATE_PRINT_CHECK_SUCCESS,
      UPDATE_PRINT_CHECK_FAILURE,
    ],
    promise: client => client.post('printCheck', { data, headers })
  }

}

export const getPrintOrderTicket = (data) => {
  const headers = getHeaders();

  return {
    types: [
      GET_PRINT_ORDER_TICKET_REQUESTED,
      GET_PRINT_ORDER_TICKET_SUCCESS,
      GET_PRINT_ORDER_TICKET_FAILURE,
    ],
    promise: client => client.post('getPrintOrderTicket', { data, headers })
  }

}

export const tableReceiptPrint = (data) => {
  const headers = getHeaders();

  return {
    types: [
      TABLE_RECEIPT_REQUESTED,
      TABLE_RECEIPT_SUCCESS,
      TABLE_RECEIPT_FAILURE,
    ],
    promise: client => client.post('tableReceiptPrint', { data, headers })
  }

}

export const emailReceipt = (data) => {
  const headers = getHeaders();

  return {
    types: [
      SEND_RECEIPT_TO_EMAIL_REQUESTED,
      SEND_RECEIPT_TO_EMAIL_SUCCESS,
      SEND_RECEIPT_TO_EMAIL_FAILURE,
    ],
    promise: client => client.post('emailReceipt', { data, headers })
  }

}

export const getMemberDetails = (memberId) => {
  const headers = getHeaders();

  return {
    types: [
      GET_MEMBER_DETAILS_REQUESTED,
      GET_MEMBER_DETAILS_SUCCESS,
      GET_MEMBER_DETAILS_FAILURE,
    ],
    promise: client => client.get(`getMemberDetails/${memberId.memberId}`, { headers })
  }

}

export const smsReceipt = (data) => {
  const headers = getHeaders();

  return {
    types: [
      SEND_RECEIPT_TO_SMS_REQUESTED,
      SEND_RECEIPT_TO_SMS_SUCCESS,
      SEND_RECEIPT_TO_SMS_FAILURE,
    ],
    promise: client => client.post('smsReceipt', { data, headers })
  }

}

export const getFutureOrdersSummary = (data) => {
  const headers = getHeaders();

  return {
    types: [
      GET_FUTURE_ORDERS_SUMMARY_REQUESTED,
      GET_FUTURE_ORDERS_SUMMARY_SUCCESS,
      GET_FUTURE_ORDERS_SUMMARY_FAILURE,
    ],
    promise: client => client.post('futureOrderSummary', { data, headers })
  }
}

export const getFutureOrderDetail = (data) => {
  const headers = getHeaders();

  return {
    types: [
      GET_FUTURE_ORDER_DETAIL_REQUESTED,
      GET_FUTURE_ORDER_DETAIL_SUCCESS,
      GET_FUTURE_ORDER_DETAIL_FAILURE,
    ],
    promise: client => client.post('futureOrderDetail', { data, headers })
  }
}

export const generateTextToPay = (data) => {
  const headers = getHeaders();

  return {
    types: [
      SEND_TEXT_TO_PAY_REQUESTED,
      SEND_TEXT_TO_PAY_SUCCESS,
      SEND_TEXT_TO_PAY_FAILURE,
    ],
    promise: client => client.post('generateTextToPay', { data, headers })
  }
}

export const acknowledgeNotification = (data) => {
  const headers = getHeaders();
  return {
    types: [ACKNOWLEDGE_NOTIFICATION_REQUESTED, ACKNOWLEDGE_NOTIFICATION_SUCCESS, ACKNOWLEDGE_NOTIFICATION_FAILURE],
    promise: client => client.post('acknowledgeNotification', { data, headers })
  }
}